// export const IMAGE_LAZY =
//   'data:image/gif;base64,R0lGODdhAQABAPAAAMPDwwAAACwAAAAAAQABAAACAkQBADs=';

export const IMAGE_LAZY =
  'data:image/gif;base64,R0lGODlheAB4APQRAM3Nzc/Pz9HR0dTU1NXV1dbW1tfX19jY2NnZ2dra2tvb29zc3N3d3d7e3t/f3+Dg4OLi4gD/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQF9QERACwAAAAAeAB4AAAF/2AkjmRpnmiqrmzrvnAsz3Rt33iu73zv/8CgcEgsGo/IpHLJbDqf0Kh0Sq1ar9isdsvter/gsBgFWYylCEMCcXYSFIXFO95WHtJr/J1dJ+7jc3Jwcn1Bg3qIan+FPYCHj46OjDmJeYqVfwqTNZaQgpGfoZswA5iml6h5oywOga6er6Cuq2SZp522qXu0JLewv7KPvBEMubi+yHzDusChsc5mw73Jx8yX0ifQwdvO2CrG1tVr3iul3M+B5C7N1urEhCsP4bEtb4WW9cj5affC5dqC9tHpU0mgHoPjCGozyCpYP0z5EOJTyA0HgGYPwfGjMS9hnXOHZIh7lXEknnUmUf+VZKfpHzpPK1N6LMFSV8yaJloBfHlTZk6ZuXqy+1lTFEWNzIgCPXgUZCSlRe01RdoJ6lIDQs9ZLZpV41agXbd9ZRnW2NiUZWWdxTh16dqRaSG9/RW3Ks2rquqGvBu1wSRqtuYy/bsTmGA4q/Au4nuL10utjBcu65g0ciJsTiVPg0ZO8UnLd9Q93mnV3TvPSk2LyEzvrgDVq6mahZ1iNDratSkfw42CtVzeh1MBN2Eb1nDQspUdP923wPIRntU8j+0b0HTmgJUfr/7pevQE3pvDm54973XsTs9DTy5d/Xrb7jebjI+8O/364O/X158tMP/S//XXXoD9EWjggQgmqOATggw26OCDEEYo4YQUVmjhhdiEAAA7';

import { TabProps, UseToastOptions } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { titelize } from '@helpers/string';
import { IOption } from '@interfaces/IOption';

export const dynamicOptions: { ssr: boolean } = { ssr: false };
export const dynamicOptionsSsr: { ssr: boolean } = { ssr: false };

export const keyName = process.env.NEXT_PUBLIC_SECRET_KEY ?? 'auth-key-brand';
export const brandKey = 'brand';
export const employeeKey = 'employee';
export const storageKey = process.env.NEXT_PUBLIC_STORAGE_KEY ?? 'root';

export const SocialMediaEmbed = styled.iframe`
  margin: 0;
  padding: 0;
  width: 100%;
  height: auto;
`;

export const tabStyle: TabProps = {
  rounded: 'md',
  fontSize: 'sm',
  fontWeight: '600',
  px: 4,
  color: 'font.ink',
  whiteSpace: 'nowrap',
  _selected: {
    bg: 'white',
    color: 'font.ink',
  },
};

export const toastOptions: UseToastOptions = {
  isClosable: true,
  position: 'top-right',
  duration: 3000,
  variant: 'solid',
};

type TToast = {
  toast: any;
  description: string;
  status: 'error' | 'success' | 'warning';
  title: string;
  duration?: number;
};

export const showToast = ({
  toast,
  description,
  status,
  title,
  duration,
}: TToast) => {
  toast.closeAll();
  toast({
    description: description || 'Failed',
    status,
    ...(title ? { title } : {}),
    ...toastOptions,
    duration,
  });
};

export const pageTitle = [
  {
    screen: 'settings',
    title: 'Settings',
  },
  {
    screen: 'my-voucher',
    title: 'My Voucher',
  },
  {
    screen: 'transaction',
    title: 'Daftar Transaksi',
  },
  {
    screen: 'invoice',
    title: 'Menunggu Pembayaran',
  },
  {
    screen: 'notification',
    title: 'Notification',
  },
  {
    screen: 'notification',
    title: 'Notification',
  },
  {
    screen: 'point',
    title: 'Point',
  },
];

export const sortingOptions = [
  { label: 'Paling Relevan', value: 'relevance' },
  { label: 'Produk Termurah', value: 'lowest' },
  { label: 'Produk Termahal', value: 'highest' },
];

export const statusOrder: IOption[] = [
  {
    label: 'Semua Status',
    value: '',
  },
  {
    label: 'Pending',
    value: 'pending',
  },
  {
    label: 'Lunas',
    value: 'paid',
  },
  {
    label: 'Diproses',
    value: 'process',
  },
  {
    label: 'Pick',
    value: 'pick,picked',
  },
  {
    label: 'Packing',
    value: 'packing,packed',
  },
  {
    label: 'Siap Dikirim',
    value: 'ready_to_pickup',
  },
  {
    label: 'Sent Booking',
    value: 'sent_booking',
  },
  {
    label: 'Dikirim',
    value: 'sent',
  },
  {
    label: 'Selesai',
    value: 'completed',
  },
  {
    label: 'Returned',
    value: 'returned',
  },
  {
    label: 'Request Cancel',
    value: 'request_cancel',
  },
  {
    label: 'Dibatalkan',
    value: 'cancelled',
  },
];

export const getStatusColor = (status) => {
  switch (status) {
    case 'pending':
      return 'gray';
    case 'paid':
      return 'green';
    case 'process':
      return 'blue';
    case 'pick':
    case 'picked':
      return 'cyan';
    case 'packing':
    case 'packed':
      return 'orange';
    case 'ready_to_pickup':
      return 'yellow';
    case 'sent_booking':
      return 'purple';
    case 'sent':
      return 'teal';
    case 'completed':
      return 'green';
    case 'returned':
      return 'red';
    case 'request_cancel':
      return 'pink';
    case 'cancelled':
      return 'red';
    default:
      return 'gray';
  }
};

export const getStatusLabel = (value) => {
  switch (value) {
    // case 'pending':
    //   return 'Pending';
    // case 'paid':
    //   return 'Lunas';
    // case 'process':
    //   return 'Diproses';
    // case 'pick':
    // case 'picked':
    //   return 'Pick';
    // case 'packing':
    // case 'packed':
    //   return 'Packing';
    // case 'ready_to_pickup':
    //   return 'Siap Dikirim';
    // case 'sent_booking':
    //   return 'Sent Booking';
    // case 'sent':
    //   return 'Dikirim';
    // case 'completed':
    //   return 'Selesai';
    // case 'returned':
    //   return 'Returned';
    // case 'request_cancel':
    //   return 'Request Cancel';
    // case 'cancelled':
    //   return 'Dibatalkan';
    default:
      return titelize(value);
  }
};

export const statusOrderReturn: IOption[] = [
  {
    label: 'Semua Status',
    value: '',
  },
  {
    label: 'Request',
    value: 'request_return',
  },
  {
    label: 'Selesai',
    value: 'returned',
  },
  {
    label: 'Dibatalkan',
    value: 'cancelled_return',
  },
];

export const statusInvoice: IOption[] = [
  { label: 'Semua Status', value: '' },
  { label: 'Menunggu Pembayaran', value: 'unpaid' },
  { label: 'Lunas', value: 'paid' },
  { label: 'Dibatalkan', value: 'canceled' },
];

export const metodeInvoice: IOption[] = [
  { label: 'Semua Metode Pembayaran', value: '' },
  { label: 'Transfer Manual', value: 'true' },
  { label: 'Pembayaran Otomatis', value: 'false' },
];

export const filterDateOption: IOption[] = [
  { label: 'Semua', value: 'all' },
  { label: 'Hari Ini', value: 'today' },
  { label: '30 Hari Terahir', value: 'month' },
  { label: 'Pilih Tanggal Sendiri', value: 'custom' },
];

export const valueByRating = (rate: number) => {
  switch (rate) {
    case 1:
      return 'Sangat Buruk';
    case 2:
      return 'Buruk';
    case 3:
      return 'Cukup';
    case 4:
      return 'Baik';
    case 5:
      return 'Sangat Baik';
    default:
      return '';
  }
};

export const optionsBrand: IOption[] = [
  {
    value: 'published',
    label: 'Published',
  },
  {
    value: 'unpublished',
    label: 'Unpublished',
  },
];

export const optionsTemplate: IOption[] = [
  {
    value: 'active',
    label: 'Aktif',
  },
  {
    value: 'inactive',
    label: 'Nonaktif',
  },
];

export const filterSync: IOption[] = [
  { label: 'Semua', value: '' },
  { label: 'Sinkron Shopee', value: 'true' },
  { label: 'Belum Sinkron Shopee', value: 'false' },
];

export const optionsStatusGeneral: IOption[] = [
  {
    value: '',
    label: 'Semua Status',
  },
  {
    value: 'published',
    label: 'Published',
  },
  {
    value: 'unpublished',
    label: 'Unpublished',
  },
];

export const optionsTypeWarehouse: IOption[] = [
  {
    value: 'internal',
    label: 'Internal',
  },
  {
    value: 'external',
    label: 'External',
  },
];

export const optionsStatusAdmin: IOption[] = [
  {
    value: '',
    label: 'Semua Status',
  },
  {
    value: 'activated',
    label: 'Aktif',
  },
  {
    value: 'inactivated',
    label: 'Nonaktif',
  },
];

export const optionsStatusPurchase: IOption[] = [
  {
    value: '',
    label: 'Semua Status',
  },
  {
    value: 'draft',
    label: 'Draft',
  },
  {
    value: 'pending',
    label: 'Pending',
  },
  {
    value: 'process',
    label: 'Process',
  },
  {
    value: 'completed',
    label: 'Completed',
  },
];

export const optionsStatusPurchaseTransition: IOption[] = [
  {
    value: '',
    label: 'Semua Status',
  },
  {
    value: 'received',
    label: 'Received',
  },
  {
    value: 'checked',
    label: 'Checked',
  },
];

export const optionsStatusAsset: IOption[] = [
  {
    value: 'available',
    label: 'Available',
  },
  {
    value: 'in_use',
    label: 'In Use',
  },
  {
    value: 'lost',
    label: 'Lost',
  },
  {
    value: 'broken',
    label: 'Broken',
  },
];

export const optionTypeBin: IOption[] = [
  {
    value: 'stock',
    label: 'Stock',
  },
  {
    value: 'damaged',
    label: 'Damaged',
  },
  {
    value: 'transit',
    label: 'Transit',
  },
];
